import {GlobalService} from '../services/global.service';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { PositionPage } from '../pages/position/position';
import { IncomeSheetPage } from '../pages/income-sheet/income-sheet';
import { DailyPage } from '../pages/daily/daily';
import { InvoicePage } from '../pages/invoice/invoice';
import { LoginPage } from '../pages/login/login';
import { DailySumPage } from '../pages/daily-sum/daily-sum';
import { HttpModule, Http } from '@angular/http';
import { Network } from '@ionic-native/network';
import { DatePipe } from '@angular/common';
import { IonicStorageModule } from '@ionic/storage';
import { MyPosProvider } from '../providers/my-pos/my-pos';
//import{GlobalService} from '../pages/Global/Global';
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    PositionPage,
    IncomeSheetPage ,
    DailyPage ,
    InvoicePage,
    LoginPage,
    DailySumPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    PositionPage,
    IncomeSheetPage,
    DailyPage,
    InvoicePage,
    LoginPage,
    DailySumPage
  ],
  providers: [
    DatePipe,
    GlobalService,
    StatusBar,
    Network,
    SplashScreen,
    MyPosProvider,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts